import {
  EURO_NETWORK_REQUEST, 
  EURO_NETWORK_RESPONSE,
  EURO_NETWORK_FAILURE, 
    
  } from "../../actions/types";
  
  
  const initialState = {
    // keyword: "",
    isFetching: false,
    results: [],
    // sortItem: { value: "CITATION", label: "Citation" },
    error: false,
    isInitalScreen: true,
    statusCode: 0,
    totalTrials: 0,
    // from: 0,
    // size: 20,
    // isMoreResult: true,
    // isMoreResultFetching: false
  };
  
  const setFetching = (state, action) => {
    return {
      ...state,
      isFetching: true,
      results: [],
    //   keyword: action.payload.keyword,
      isInitalScreen: false,
      statusCode: 0,
      totalTrials: 0,
    //   from: 0,
    //   size: 20,
    //   isMoreResult: true
    };
  };
  
  const setFailure = (state, action) => {
    return {
      ...state,
      isFetching: false,
      error: true,
      results: [],
      totalTrials: 0
    };
  };
  
  const setResults = (state, action) => {
    let results = action.payload.results || [];
    let totalTrials = action.payload.totalTrials || 0;
    let statusCode = action.payload.statusCode;
    // let isMoreResult = true;
  
    // if (totalTrials <= 20) {
    //   isMoreResult = false;
    // }
  
    return {
      ...state,
      isFetching: false,
      error: false,
      results,
      totalTrials,
    //   isMoreResult,
      statusCode
    };
  };
  
  
  
  
  
  
  export default (state = initialState, action) => {
    switch (action.type) {
      case EURO_NETWORK_REQUEST:
        return setFetching(state, action);
        break;
  
      case EURO_NETWORK_RESPONSE:
        return setResults(state, action);
  
      case EURO_NETWORK_FAILURE:
        return setFailure(state, action);
  
      default:
        return state;
        break;
    }
  };
  
  